<template>
  <v-container>
    <v-row align="center" class="ml-2 mr-2">
      <v-col cols="12" align="center">
        <img placeholder="Senior" style="width: 120px; margin-right: 10px; margin-top: 10px;" src="@/assets/icone-senior-connect_colorido-solo.svg" />
        <h1 class="light cabecalho" style="color: #009280">Senior Connect</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        xs="12"
        sm="8"
        md="8"
        lg="6"
        xl="4"
        offset-sm="2"
        offset-md="2"
        offset-lg="3"
        offset-xl="4"
      >
        <v-card>
          <div class="pt-2 pr-2 pb-0 pl-2" v-if="errorMessage.length">
            <v-alert type="error" class="mb-0">{{errorMessage}}</v-alert>
          </div>
          <div class="pt-2 pr-2 pb-0 pl-2" v-if="warningMessage.length">
            <v-alert type="warning" class="mb-0">{{warningMessage}}</v-alert>
          </div>
          <v-card-title>
            <h3 class="light">{{$t('keywords.login')}}</h3>
          </v-card-title>
          <v-form ref="form" v-model="valid" v-on:submit.prevent>
            <v-card-text>
              <v-text-field
                v-model="username"
                :label="$t('keywords.username')"
                prepend-icon="mdi-account-circle"
                :rules="requiredRules(username)"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                :label="$t('keywords.password')"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPassword = !showPassword"
                :rules="requiredRules(password)"
                required
              ></v-text-field>
              <div class="captchaBox">
                <VueRecaptcha
                  ref="reCaptcha"
                  @verify="() => this.captchaVerified = true"
                  @expired="() => this.captchaVerified = false"
                  :sitekey="reCaptchaSiteKey"
                  language=""
                />
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                :disabled="!this.captchaEnvironment()"
                color="#009280"
                class="white--text"
                @click="login"
              >{{$t('keywords.login')}}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.light {
  font-weight: 300;
}
.cabecalho {
  margin-top: 45px;
  display: inline-block;
  vertical-align: top;
}
</style>
<script>
import { VueRecaptcha } from 'vue-recaptcha'
import config from '../../config'
import LocalStorageService from '../../services/LocalStorageService'
import LoginService from '../../services/LoginService'
import { requiredRules } from '../../utils/rules'

import ClientLoginService from '../../services/ClientLoginService'

export default {
  components: { VueRecaptcha },
  data: () => ({
    requiredRules,
    valid: true,
    username: '',
    password: '',
    showPassword: false,
    errorMessage: '',
    warningMessage: '',
    captchaVerified: false
  }),

  methods: {
    captchaEnvironment () {
      return config.ENV !== 'dev' ? this.captchaVerified : true
    },
    login () {
      LocalStorageService.deleteLoginMessage()
      LocalStorageService.setUsername(this.username)
      if (this.captchaEnvironment()) {
        LoginService.login(this.username, this.password)
          .then(({ headers: { authorization } }) => {
            if (authorization) {
              LocalStorageService.setAuthorization(authorization)
              this.updateUser()
            } else {
              this.errorMessage = this.$t('login.error.credentials')
              console.error(this.errorMessage)
            }
          })
          .catch(error => {
            console.error(error)
            this.errorMessage = this.$t('login.error.credentials')
          })
      } else {
        this.errorMessage = ('Recaptcha!')
      }
    },
    updateUser () {
      LoginService.getUserDetails()
        .then(({ data: user }) => {
          const { username, clientPrefix } = user.userKey
          LocalStorageService.setUserDetails({ ...user, username, clientPrefix })
          LocalStorageService.setClientPrefix(clientPrefix)
          // LocalStorageService.setAccessUrl(config.DEFAULT_BASE_BACKEND_URL)
          this.$router.push('/select-client')
          // this.hasPermission(user, 'MASTER', 'MULTI_TENANT')
          //  ? this.$router.push('/select-client')
          //  : this.clientLogin(clientPrefix)
        })
        .catch(error => {
          console.error(error)
          this.errorMessage = this.$t('login.error.found_user')
        })
    },
    clientLogin (clientPrefix) {
      ClientLoginService.findById(clientPrefix)
        .then(response => {
          const { clientName, accessUrl } = response.data
          LocalStorageService.setClientName(clientName)
          LocalStorageService.setAccessUrl(accessUrl)

          console.debug('LOGIN - Setting Versions')
          this.$versionable.update()
          this.$router.push('/dashboard')
        })
        .catch(error => {
          console.error(error)
          this.errorMessage = this.$t('login.error.client_user')
        })
    },
    hasPermission (user, ...validPermissions) {
      return this.$versionable.decorators.users.hasPermission(user, ...validPermissions)
    }
  },

  mounted () {
    this.warningMessage = LocalStorageService.getLoginMessage() || ''
    this.username = LocalStorageService.getUsername()
    localStorage.clear()
  },
  computed: {
    reCaptchaSiteKey: () => config.RECAPTCHA_SITEKEY
  }

}
</script>
<style scoped>
  .captchaBox {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>
